import { Component, inject } from '@angular/core';
import { MatDialogActions, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-startup-loading-dialog',
    templateUrl: './startup-loading-dialog.component.html',
    styleUrls: ['./startup-loading-dialog.component.css'],
    imports: [MatDialogActions]
})
export class StartupLoadingDialogComponent {
    private dialogRef = inject<MatDialogRef<StartupLoadingDialogComponent>>(MatDialogRef);

    public stillGoing = true;
    public errorMessage: string;

    showError(errorMessage: string): void {
        this.errorMessage = errorMessage;
        this.stillGoing = false;
    }

    close(): void {
        this.dialogRef.close();
    }
}
